const getRandomNum = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
}

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};


function formatPhoneNumber(number) {
    const countryCode = '+91';
    if (!number.startsWith(countryCode)) {
        return countryCode + number;
    }

    return number;
}

function formatDatePickerDate(dateRange, key) {
    const dates = dateRange[key]?.map(date => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
      });
    return dates
}





module.exports = {
    getRandomNum,
    formatDate,
    formatPhoneNumber,
    formatDatePickerDate
}